/**
 * Conditional logging utility that respects the window.__WELD_APP__.logging flag.
 * Enable logging in production by setting: window.__WELD_APP__.logging = true
 */

/* eslint-disable no-console */
export const devLog = (...args: any[]) => {
  if (window.__WELD_APP__?.logging) {
    console.debug(...args);
  }
};

export const devWarn = (...args: any[]) => {
  if (window.__WELD_APP__?.logging) {
    console.warn(...args);
  }
};

export const devError = (...args: any[]) => {
  if (window.__WELD_APP__?.logging) {
    console.error(...args);
  }
};
/* eslint-enable no-console */
